import React from 'react';
import { ComposedChart, XAxis, YAxis, Tooltip, Legend, CartesianGrid, Bar, Line } from 'recharts';

// Función para formatear los números en miles
const formatThousands = (value) => `${(value / 1000).toFixed(2)}B`;
const formatThousandsNoDecimals = (value) => `${(value / 1000).toFixed(0)}B`;
const formatPercentages = (value) => `${value.toFixed(2)}%`;

const MyChart = ({ stock }) => {

  const data = [
    { name: "2018", MargenOperativo: (stock.NetIncome2018 / stock.Revenue2018) * 100, Ventas: stock.Revenue2018, Beneficios: stock.NetIncome2018 },
    { name: "2019", MargenOperativo: (stock.NetIncome2019 / stock.Revenue2019) * 100, Ventas: stock.Revenue2019, Beneficios: stock.NetIncome2019 },
    { name: "2020", MargenOperativo: (stock.NetIncome2020 / stock.Revenue2020) * 100, Ventas: stock.Revenue2020, Beneficios: stock.NetIncome2020 },
    { name: "2021", MargenOperativo: (stock.NetIncome2021 / stock.Revenue2021) * 100, Ventas: stock.Revenue2021, Beneficios: stock.NetIncome2021 },
    { name: "2022", MargenOperativo: (stock.NetIncome2022 / stock.Revenue2022) * 100, Ventas: stock.Revenue2022, Beneficios: stock.NetIncome2022 },
    { name: "2023", MargenOperativo: (stock.NetIncome2023 / stock.Revenue2023) * 100, Ventas: stock.Revenue2023, Beneficios: stock.NetIncome2023 }
  ];

  const margenOperativoValues = data.map(entry => entry.MargenOperativo);
  const margenOperativoMin = Math.min(...margenOperativoValues);
  const margenOperativoMax = Math.max(...margenOperativoValues);

  const ventasValues = data.map(entry => entry.Ventas);
  const beneficiosValues = data.map(entry => entry.Beneficios);
  const minVentasBeneficios = Math.min(...ventasValues, ...beneficiosValues);
  const maxVentasBeneficios = Math.max(...ventasValues, ...beneficiosValues);

  // Definir un rango más estrecho para el eje del Margen Operativo
  const margenOperativoDomain = [Math.max(0, margenOperativoMin - 5), Math.min(100, margenOperativoMax + 5)];
  const minYBeneficios = minVentasBeneficios >= 0 ? 0 : minVentasBeneficios;
  let maxYBeneficios;
  if (maxVentasBeneficios < 5000) {
    maxYBeneficios = maxVentasBeneficios + 500;
  } else if (maxVentasBeneficios < 10000) {
    maxYBeneficios = maxVentasBeneficios + 2000;
  } else if (maxVentasBeneficios < 40000) {
    maxYBeneficios = maxVentasBeneficios + 5000;
  } else {
    maxYBeneficios = maxVentasBeneficios + 10000;
  }


  return (
    <ComposedChart width={730} height={350} data={data}>
      <XAxis dataKey="name" />
      <YAxis yAxisId="margenOperativo" orientation="left" domain={margenOperativoDomain} tickFormatter={formatPercentages} />
      <YAxis yAxisId="ventasBeneficios" orientation="right" domain={[minYBeneficios, maxYBeneficios]} tickFormatter={formatThousandsNoDecimals}/>
      <Tooltip
        formatter={(value, name, props) => {
          if (name === 'MargenOperativo') {
            return [formatPercentages(value), name];
          }
          return [formatThousands(value), name];
        }}
      />
      <Legend />
      <CartesianGrid stroke="#f5f5f5" />
      <Bar dataKey="Ventas" barSize={20} fill="#413ea0" yAxisId="ventasBeneficios" />
      <Bar dataKey="Beneficios" barSize={20} fill="#8884d8" yAxisId="ventasBeneficios" />
      <Line type="monotone" dataKey="MargenOperativo" stroke="#ff7300" yAxisId="margenOperativo" />
    </ComposedChart>
  );

}

export default MyChart;








  // const data = [
  //   { name: "2019", BPA: stock.NetIncome2019/stock.Acciones2019, Beneficio: stock.NetIncome2019, Acciones: stock.Acciones2019 },
  //   { name: "2020", BPA: stock.NetIncome2020/stock.Acciones2020, Beneficio: stock.NetIncome2020, Acciones: stock.Acciones2020 },
  //   { name: "2021", BPA: stock.NetIncome2021/stock.Acciones2021, Beneficio: stock.NetIncome2021, Acciones: stock.Acciones2021 },
  //   { name: "2022", BPA: stock.NetIncome2022/stock.Acciones2022, Beneficio: stock.NetIncome2022, Acciones: stock.Acciones2022 },
  //   { name: "2023", BPA: stock.NetIncome2023/stock.Acciones2023, Beneficio: stock.NetIncome2023, Acciones: stock.Acciones2023 }
  // ];